import { render, staticRenderFns } from "./ModalSkeleton.vue?vue&type=template&id=3f97d5e7&"
import script from "./ModalSkeleton.vue?vue&type=script&lang=js&"
export * from "./ModalSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports